<div class="container">

  <app-header-dialog [iconName]="'store_mall_directory'">
    Texto
  </app-header-dialog>

  <div class='content'>

    <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.name.hasError('required')">
          O nome é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Formato</mat-label>
        <mat-select (ngModelChange)='selectFormat($event)' [formControl]='entityForm.controls.format'>
          <mat-option *ngFor="let format of formats" [value]="format.id">
            {{ format.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngIf='flag_plain'>

        <mat-tab-group id='tabs'>
          <mat-tab>
            <ng-template mat-tab-mat-label>
              <mat-icon class='tab-icon'>settings</mat-icon>
              Português
            </ng-template>

            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Texto PT</mat-label>
              <textarea class='text-area' matInput [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.plain_text" autocomplete="off">
                                </textarea>

              <mat-error *ngIf="entityForm.controls.plain_text.hasError('required')">
                O texto pt é obrigatória.
              </mat-error>
            </mat-form-field>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-mat-label>
              <mat-icon class='tab-icon'>settings</mat-icon>
              Inglês
            </ng-template>

            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Texto EN</mat-label>
              <textarea class='text-area' matInput [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.plain_text_en" autocomplete="off">
                                </textarea>

              <mat-error *ngIf="entityForm.controls.plain_text_en.hasError('required')">
                O texto en é obrigatório.
              </mat-error>
            </mat-form-field>
          </mat-tab>

        </mat-tab-group>

      </div>

      <div *ngIf='flag_html'>

        <mat-tab-group id='tabs'>
          <mat-tab style='height: 440px; max-height: 440px'>
            <ng-template mat-tab-mat-label>
              <mat-icon class='tab-icon'>settings</mat-icon>
              Português
            </ng-template>

            <ckeditor [config]="{ 
                          toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
              [formControl]="entityForm.controls.html_text" [editor]="Editor"></ckeditor>


          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-mat-label>
              <mat-icon class='tab-icon'>settings</mat-icon>
              Inglês
            </ng-template>

            <ckeditor [config]="{ 
                            toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
              [formControl]="entityForm.controls.html_text_en" [editor]="Editor"></ckeditor>
            <mat-error *ngIf="entityForm.controls.html_text_en.hasError('required')">
              O texto en é obrigatório.
            </mat-error>

          </mat-tab>

        </mat-tab-group>

      </div>

    </form>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <div [ngClass]="{hidden: !spinner}">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
    <button mat-raised-button (click)='insert()' [disabled]="entityForm.invalid" *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid" *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>